
import { defineComponent, reactive, PropType } from "vue";
import ActionInterface from "./Interface/ActionInterface";

export default defineComponent({
  name: "tabela-listagem",
  components: {},
  props: {
    listas: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    cabecalhoTabela: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    dadosTabela: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      required: false,
    },
    rotaEdit: {
      type: String,
      required: false,
      default: "",
    },
    acoes: {
      type: Array as PropType<ActionInterface[]>,
      required: false,
      default: () => [],
    },
    hideAction: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const rota = reactive({
      rotaId: "",
    });

    return { rota: rota.rotaId };
  },
});
